import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["src", "alt"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getContrastHex } from '../helper';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import { SIZES } from '../helper';
import { colorsPallet } from './constant';
const Root = styled.span.withConfig({
  displayName: "Avatar__Root",
  componentId: "sc-140nruv-0"
})(["", " width:40px;height:40px;border-radius:var(--border-radius-circle);font:var(--text-md-extrabold);overflow:hidden;img{width:100%;}", " ", " ", " ", " ", ""], ScopedCssBaseline, isFallback => isFallback && css(["text-transform:uppercase;display:flex;align-items:center;justify-content:center;"]), _ref => {
  let {
    size
  } = _ref;
  return size === SIZES.MD && css(["width:80px;height:80px;font:var(--text-xxl-extrabold);"]);
}, _ref2 => {
  let {
    size
  } = _ref2;
  return size === SIZES.LG && css(["width:120px;height:120px;font:var(--text-xxl-extrabold);"]);
}, _ref3 => {
  let {
    isBrand
  } = _ref3;
  return isBrand && css(["border-radius:var(--border-radius-rounded);"]);
}, _ref4 => {
  let {
    color
  } = _ref4;
  return color && css(["color:var(", ");background-color:", ";"], getContrastHex(color), color);
});
const Avatar = /*#__PURE__*/forwardRef((_ref5, ref) => {
  let {
      src,
      alt
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded);
  const words = alt.split(' ');
  let children = words[0].substring(0, 2);
  if (words.length > 1) {
    children = words[0].charAt();
    children += words[words.length - 1].charAt();
  }
  return /*#__PURE__*/React.createElement(Root, _extends({
    isFallback: !!src
  }, rest, {
    ref: ref
  }), src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt
  }) : children);
});
Avatar.sizes = {
  sm: SIZES.SM,
  md: SIZES.MD,
  lg: SIZES.LG
};
Avatar.colors = colorsPallet;
Avatar.displayName = 'Avatar';
Avatar.Style = Root;
Avatar.defaultProps = {
  src: '',
  size: Avatar.sizes.sm,
  isBrand: false,
  color: Avatar.colors.neutralSurfaceHighEmphasis
};
process.env.NODE_ENV !== "production" ? Avatar.propTypes = {
  /**
   * Sets image source
   */
  src: PropTypes.string,
  /**
   * Sets alt text
   */
  alt: PropTypes.string.isRequired,
  /**
   * Sets avatar width and height
   */
  size: PropTypes.oneOf([Avatar.sizes.sm, Avatar.sizes.md, Avatar.sizes.lg]),
  /**
   * Sets avatar color and background-color
   */
  color: PropTypes.oneOf(Object.values(Avatar.colors)),
  /**
   * Sets avatar type
   */
  isBrand: PropTypes.bool
} : void 0;
export default Avatar;